export function convertTimeString(timeString) {
    const localTimeStamp =  new Date(timeString + 'Z');

    // Convert to AM/PM
    let hoursTime, ampm;
    if (localTimeStamp.getHours() > 12) {
        hoursTime = `${localTimeStamp.getHours() - 12}`
        ampm = 'PM'
    } else if (localTimeStamp.getHours() === 12) {
        hoursTime = `${localTimeStamp.getHours()}`
        ampm = 'PM'
    } else {
        hoursTime = `${localTimeStamp.getHours()}`
        ampm = 'AM'
    }
    // Format given time string to readable date Object
    return `${localTimeStamp.getMonth() + 1}/${localTimeStamp.getDate()}/${localTimeStamp.getFullYear()}, ${hoursTime}:${String(localTimeStamp.getMinutes()).padStart(2, "0")} ${ampm}`
}

export function grabLocalTime(timeString) {
    const localTimeStamp =  new Date(timeString + 'Z');

    return localTimeStamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}


export function calculateAndConvertTime(interval) {
    const currentTime = new Date();

    switch(interval) {
        case ('current'): {
            const currentUTCMonthFormatted = String(currentTime.getUTCMonth() + 1).padStart(2, '0')
            const currentUTCDayFormatted = String(currentTime.getUTCDate()).padStart(2, '0')
            const currentUTCHoursFormatted = String(currentTime.getUTCHours()).padStart(2, '0')
            const currentUTCMinutesFormatted = String(currentTime.getUTCMinutes()).padStart(2, '0')
            const currentUTCSecondsFormatted = String(currentTime.getUTCSeconds()).padStart(2, '0')
            return `${currentTime.getUTCFullYear()}-${currentUTCMonthFormatted}-${currentUTCDayFormatted}T${currentUTCHoursFormatted}:${currentUTCMinutesFormatted}:${currentUTCSecondsFormatted}`
        } case ('24 hours ago'): {
            // Support retrieval of notes from the last 7 days
            const pastTime = new Date(currentTime.getTime() - (24 * 60 * 60 * 1000))
            const pastUTCMonthFormatted = String(pastTime.getUTCMonth() + 1).padStart(2, '0')
            const pastUTCDayFormatted = String(pastTime.getUTCDate()).padStart(2, '0')
            const pastUTCHoursFormatted = String(pastTime.getUTCHours()).padStart(2, '0')
            const pastUTCMinutesFormatted = String(pastTime.getUTCMinutes()).padStart(2, '0')
            const pastUTCSecondsFormatted = String(pastTime.getUTCSeconds()).padStart(2, '0')

            return `${pastTime.getUTCFullYear()}-${pastUTCMonthFormatted}-${pastUTCDayFormatted}T${pastUTCHoursFormatted}:${pastUTCMinutesFormatted}:${pastUTCSecondsFormatted}`;
        } case ('last 7 days'): {
            // Support retrieval of notes from the last 7 days
            const pastTime = new Date(currentTime.getTime() - (7 * 24 * 60 * 60 * 1000))
            const pastUTCMonthFormatted = String(pastTime.getUTCMonth() + 1).padStart(2, '0')
            const pastUTCDayFormatted = String(pastTime.getUTCDate()).padStart(2, '0')
            const pastUTCHoursFormatted = String(pastTime.getUTCHours()).padStart(2, '0')
            const pastUTCMinutesFormatted = String(pastTime.getUTCMinutes()).padStart(2, '0')
            const pastUTCSecondsFormatted = String(pastTime.getUTCSeconds()).padStart(2, '0')

            return `${pastTime.getUTCFullYear()}-${pastUTCMonthFormatted}-${pastUTCDayFormatted}T${pastUTCHoursFormatted}:${pastUTCMinutesFormatted}:${pastUTCSecondsFormatted}`;
        } case('1 month'): {
            // Support retrieval of notes from the last month
            const pastTime = new Date(currentTime.getTime() - (30 * 24 * 60 * 60 * 1000))
            const pastUTCMonthFormatted = String(pastTime.getUTCMonth() + 1).padStart(2, '0')
            const pastUTCDayFormatted = String(pastTime.getUTCDate()).padStart(2, '0')
            const pastUTCHoursFormatted = String(pastTime.getUTCHours()).padStart(2, '0')
            const pastUTCMinutesFormatted = String(pastTime.getUTCMinutes()).padStart(2, '0')
            const pastUTCSecondsFormatted = String(pastTime.getUTCSeconds()).padStart(2, '0')

            return `${pastTime.getUTCFullYear()}-${pastUTCMonthFormatted}-${pastUTCDayFormatted}T${pastUTCHoursFormatted}:${pastUTCMinutesFormatted}:${pastUTCSecondsFormatted}`;
        } case ('3 months'): {
            const pastTime = new Date(currentTime.getTime() - (30* 3 * 24 * 60 * 60 * 1000))
            const pastUTCMonthFormatted = String(pastTime.getUTCMonth() + 1).padStart(2, '0')
            const pastUTCDayFormatted = String(pastTime.getUTCDate()).padStart(2, '0')
            const pastUTCHoursFormatted = String(pastTime.getUTCHours()).padStart(2, '0')
            const pastUTCMinutesFormatted = String(pastTime.getUTCMinutes()).padStart(2, '0')
            const pastUTCSecondsFormatted = String(pastTime.getUTCSeconds()).padStart(2, '0')

            return `${pastTime.getUTCFullYear()}-${pastUTCMonthFormatted}-${pastUTCDayFormatted}T${pastUTCHoursFormatted}:${pastUTCMinutesFormatted}:${pastUTCSecondsFormatted}`;
        } case ('1 year'): {
            const pastTime = new Date(currentTime.getTime() - (30* 12 * 24 * 60 * 60 * 1000))
            const pastUTCMonthFormatted = String(pastTime.getUTCMonth() + 1).padStart(2, '0')
            const pastUTCDayFormatted = String(pastTime.getUTCDate()).padStart(2, '0')
            const pastUTCHoursFormatted = String(pastTime.getUTCHours()).padStart(2, '0')
            const pastUTCMinutesFormatted = String(pastTime.getUTCMinutes()).padStart(2, '0')
            const pastUTCSecondsFormatted = String(pastTime.getUTCSeconds()).padStart(2, '0')

            return `${pastTime.getUTCFullYear()}-${pastUTCMonthFormatted}-${pastUTCDayFormatted}T${pastUTCHoursFormatted}:${pastUTCMinutesFormatted}:${pastUTCSecondsFormatted}`;
        } default: {
            return 'Implement it later'
        }
    }
}



export function checkWithinTheHour(isoString) {
    if (!isoString) {
        return false;
    }
    const dateObj = new Date(); // Current date-time
    const dateFromIso = new Date(isoString);
    const dateAt3UTC = new Date(Date.UTC(dateObj.getUTCFullYear(), dateObj.getUTCMonth(), dateObj.getUTCDate(), 1, 49, 0, 0));
    
    if (dateObj.getTime() > dateAt3UTC.getTime() && dateFromIso.getTime() < dateAt3UTC.getTime()) {
        return false;
    }

    // Calculate the absolute difference in milliseconds
    const diffInMs = Math.abs(dateObj.getTime() - dateFromIso.getTime());

    // Convert milliseconds to hours
    const diffInHours = diffInMs / (1000 * 60 * 60);

    return diffInHours <= 1; // true if within 1 hour, false otherwise
}

export function checkLastTimeCheckedAfter3AM(isoString) {
    if (!isoString) {
        return false;
    }

    const todayAt3AMUTC = new Date();
    todayAt3AMUTC.setUTCHours(3, 0, 0, 0);
    const dateFromIso = new Date(isoString);

    return dateFromIso > todayAt3AMUTC;
}

export function isWithinLast24Hours(isoString) {
    const givenTime = new Date(isoString).getTime();
    const now = Date.now();
    const twentyFourHoursInMs = 24 * 60 * 60 * 1000;

    return now - givenTime <= twentyFourHoursInMs;
}
